import React, { useState } from "react";
import { LOGIN } from "../../queries/login";
import { Mutation } from '@apollo/react-components';
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  Tabs,
  Tab,
  TextField,
  Fade,
} from "@material-ui/core";

// styles
import useStyles from "./styles";

// logo
import logo from "./logo.png";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";

export default function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [activeTabId, setActiveTabId] = useState(0);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");

  const handleSignIn = async (login_mutation) => {
    setError(null);
    setIsLoading(true);

    try {
      if (!loginValue && !passwordValue) throw Error('Field empty');

      setTimeout(() => {

        login_mutation({ variables: { email:loginValue, password:passwordValue }}).then(result =>{
          loginUser(userDispatch, props.history, result);
          setError(null);
          setIsLoading(false);
        }, error=>{
          setError(true);
          setIsLoading(false);
        });


        
      }, 2000);

      // throw Error('Error');
    }catch(e) {
      setError(true);
      setIsLoading(false);
    }
  }

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
        <Typography className={classes.logotypeText}>Adireto PUB</Typography>
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <Tabs
            value={activeTabId}
            onChange={(e, id) => setActiveTabId(id)}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Login" classes={{ root: classes.tab }} />
          </Tabs>
          {activeTabId === 0 && (
            <React.Fragment>
              <Typography variant="h1" className={classes.greeting}>
                Hello User
              </Typography>
              
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  Something is wrong with your login or password :(
                </Typography>
              </Fade>
              <Mutation mutation={LOGIN}>
                {login_mutation => (
                <>
                <TextField
                  id="email"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={loginValue}
                  onChange={e => setLoginValue(e.target.value)}
                  margin="normal"
                  placeholder="Email Adress"
                  type="email"
                  fullWidth
                />
                <TextField
                  id="password"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={passwordValue}
                  onKeyDown={(e) =>{
                      if (e.keyCode === 13){
                        handleSignIn(login_mutation)
                      }
                    }
                  }
                  onChange={e => setPasswordValue(e.target.value)}
                  margin="normal"
                  placeholder="Password"
                  type="password"
                  fullWidth
                />

                <div className={classes.formButtons}>
                  {isLoading ? (
                    <CircularProgress size={26} className={classes.loginLoader} />
                  ) : (

                      <Button
                      disabled={
                        loginValue.length === 0 || passwordValue.length === 0
                      }
                      onClick={() =>{
                        handleSignIn(login_mutation)
                        }
                      }
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Login
                    </Button>



                  )}
                </div>
                </>
              )}
              </Mutation>

            </React.Fragment>
          )}
        </div>
        <Typography color="primary" className={classes.copyright}>
          © 2019 Adireto. All rights reserved.
        </Typography>
      </div>
    </Grid>
  );
}